"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_safety__score__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "safety_score_hi_dark",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M56,26.7A80,80,0,1,0,165.3,56,80,80,0,0,0,56,26.7Zm62,125.6a4,4,0,0,1-1.5,5.5,1.91,1.91,0,0,1-.8.3,65.11,65.11,0,0,1-71.4-22.4,4,4,0,0,1,.8-5.6,1.61,1.61,0,0,1,.7-.4l18-8.7c15-8.6,33.1-5.3,41.8,9.7ZM39.2,113.6a4,4,0,0,1-5.6-.7,3.4,3.4,0,0,1-.7-1.5A65,65,0,0,1,140.9,49a4.07,4.07,0,0,1,.2,5.7,4.19,4.19,0,0,1-1.4.9c-26.3,10.8-46,17.6-54.1,22.3S61.6,96.1,39.2,113.6Zm100.7,30.5a3.87,3.87,0,0,1-5.6-.3,1.79,1.79,0,0,1-.5-.7l-12.5-21.6c-8.6-15-2.5-32.4,12.5-41l16.5-11.3a4.12,4.12,0,0,1,5.6,1,2.51,2.51,0,0,1,.4.7,65.44,65.44,0,0,1-16.4,73.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 16,
    style: {
      opacity: 0.059999998658895,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 14,
    style: {
      opacity: 0.119999997317791,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 8,
    style: {
      fill: "#e60000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,101.2a8.08,8.08,0,0,1-10.4-2.1A8,8,0,0,0,103.3,93a5.44,5.44,0,0,0-1.1-1.8A7.74,7.74,0,0,1,99,101.2Z",
    style: {
      opacity: 0.119999997317791,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,26.7A80,80,0,1,0,165.3,56,80,80,0,0,0,56,26.7Zm73.9,128a67.79,67.79,0,1,1,24.8-92.6h0A67.82,67.82,0,0,1,129.9,154.7Z",
    style: {
      opacity: 0.119999997317791,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8,113a65,65,0,0,1,108-62.4.1.1,0,0,0,.1.1,4.53,4.53,0,0,0-1.1-1.9,65,65,0,0,0-108,62.3,4.53,4.53,0,0,0,1.1,1.9C33.9,113.1,33.8,113.1,33.8,113Z",
    style: {
      opacity: 0.119999997317791,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.7,82.3l16.5-11.2a4,4,0,0,1,5.2.6c-.1-.2-.1-.4-.2-.6a4.1,4.1,0,0,0-5.2-2.2,1.61,1.61,0,0,0-.7.4L133.8,80.5c-15,8.6-21.1,26-12.5,41l1,1.7C113.6,108.3,119.8,90.9,134.7,82.3Z",
    style: {
      opacity: 0.119999997317791,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8,122.7l-18,8.6a4,4,0,0,0-2.1,4.8c-.1-.2-.3-.3-.4-.5a4,4,0,0,1,.8-5.6,1.61,1.61,0,0,1,.7-.4l18-8.6c15-8.6,33.1-5.3,41.8,9.7l1,1.7C97.9,117.4,79.7,114.1,64.8,122.7Z",
    style: {
      opacity: 0.119999997317791,
      isolation: "isolate"
    }
  })));
}

var _default = ic_safety__score__dark;
exports.default = _default;